<template>
  <div >
    <div v-if="!emailSetted">
      <b-alert show variant="danger" v-if="form.state.errors" v-html="submitError"></b-alert>
      <p>{{ $t('account.set-email-title') }}</p>
      <base-input v-model="email" placeholder="Email"></base-input>
      <base-button class="mt-3" @click="setEmail">{{ $t('account.setEmail') }}</base-button>
    </div>
    <div v-else>
      <p>{{ $t('account.confirm-account-message') }}</p>
    </div>
  </div>
</template>

<script>
import AccountRepository from '@/repositories/AccountRepository'
import { BAlert } from 'bootstrap-vue'

export default {
  components: {
    BAlert
  },
  data () {
    return {
      emailSetted: false,
      email: null,
      token: null,
      expiredPwd: false,
      error: null,
      submitError: null,
      form: {
        state: {
          submitted: false,
          waiting: false,
          unauthorized: false,
          errors: false
        }
      }
    }
  },
  created () {
    const token = this.$route.query.t

    if (!token) {
      this.$router.push('/unauthorized')
    } else {
      this.token = token
    }
  },
  methods: {
    setEmail () {
      AccountRepository.setEmail(this.email, this.token).then((response) => {
        if (response.data) {
          this.emailSetted = true
        } else {
          this.form.state.errors = true
          this.submitError = this.$t('account.set-email.error01')
        }
      }).catch((error) => {
          this.form.state.errors = true
          if (error.status === 401) {
            this.confirmSucessful = false
            this.submitError = this.$t('account.set-email.error01')
          } else if (error.status === 400) {
            this.confirmSucessful = false
            this.submitError = this.$t('account.set-email.error02')
          }
        })
    }
  },
  mounted () {
    this.expiredPwd = !!this.$route.query.expired
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/account/SetEmail.vue